export const SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL = "SIM_PROVIDER_ACCOUNT_DELETE_OPEN_MODAL";
export const SIM_PROVIDER_ACCOUNT_DELETE_REQUEST = "SIM_PROVIDER_ACCOUNT_DELETE_REQUEST";
export const SIM_PROVIDER_ACCOUNT_DELETE_RESULT = "SIM_PROVIDER_ACCOUNT_DELETE_RESULT";